module.exports = __webpack_public_path__ + "static/media/secure.e0aa9027.png";